import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Header = ({ onConsultationClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigation = [
    { name: 'Specialties', href: '#specialties' },
    { name: 'Services', href: '#services' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 w-full bg-white/90 backdrop-blur-md border-b border-slate-100 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_clean-energy/artifacts/6ehg0tdj_Ecologicalv%20words.png" 
              alt="Ecological Energy" 
              className="h-8 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-12">
            {navigation.map((item) => (
              <button
                key={item.name}
                onClick={() => scrollToSection(item.href)}
                className="text-slate-600 hover:text-slate-900 transition-colors font-light"
              >
                {item.name}
              </button>
            ))}
            <Button 
              onClick={onConsultationClick}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 font-medium border-0 transition-colors"
            >
              Book a Consultation
            </Button>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-slate-600 hover:text-slate-900 transition-colors"
            >
              {isMenuOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-slate-100">
          <div className="px-4 py-6 space-y-6">
            {navigation.map((item) => (
              <button
                key={item.name}
                onClick={() => scrollToSection(item.href)}
                className="block w-full text-left text-slate-600 hover:text-slate-900 transition-colors font-light"
              >
                {item.name}
              </button>
            ))}
            <Button 
              onClick={() => {
                onConsultationClick();
                setIsMenuOpen(false);
              }}
              className="w-full bg-green-600 hover:bg-green-700 text-white py-3 font-medium border-0"
            >
              Book a Consultation
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};